export const getAssociationType = (type) => {
  if (type === "personnel") {
    return "پرسنل";
  } else if (type === "retired") {
    return "بازنشسته";
  } else if (type === "contractor") {
    return "پیمانکار";
  } else if (type === "saba") {
    return "فولاد صبا";
  }
};
